<template>
  <div class="chat-entrance">
    <div class="chat-entrance-top">
      <a
        class="btn-chat btn-arrange"
        :class="{ hover: links.arrange.active }"
        :href="links.arrange.href"
      >
        <span class="icon-wrapper">
          <Arrange class="icon" />
        </span>
        <span class="btn-chat-label">{{ links.arrange.label }}</span>
      </a>
      <a
        class="btn-chat btn-knowledge mx-4"
        :class="{ hover: links.know.active }"
        :href="links.know.href"
      >
        <span class="icon-wrapper">
          <Know class="icon" />
        </span>
        <span class="btn-chat-label">{{ links.know.label }}</span>
      </a>
      <a
        class="btn-chat btn-comment"
        :class="{ hover: links.comment.active }"
        :href="links.comment.href"
      >
        <span class="icon-wrapper">
          <Contact class="icon" />
        </span>
        <span class="btn-chat-label">{{ links.comment.label }}</span>
      </a>
    </div>
    <div
      v-if="enableSearch"
      class="chat-entrance-bottom"
    >
      <div class="chat-search-container">
        <input
          class="chat-search-input"
          type="search"
          name="search"
          placeholder="Stel hier uw vraag"
          aria-label="Stel hier uw vraag"
        >
        <button
          type="submit"
          class="chat-search-input-btn"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatEntrance',
  components: {
    Arrange: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Arrange.vue'),
    Know: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Know.vue'),
    Contact: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Contact.vue'),
  },
  props: {
    enableSearch: {
      type: Boolean,
      default: false,
    },
    links: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="postcss" scoped>
.chat-entrance {
  @apply flex flex-col mx-auto items-center rounded;
  width: 100%;

  .btn-chat {
    @apply flex flex-col mb-0 no-underline;

    @screen md {
      width: 110px;
    }

    &:hover,
    &.hover {
      @apply text-primary-bravo;

      >>> .icon {
        @apply text-primary-bravo fill-current;
      }

      .btn-chat-label {
        @apply inline-block text-primary-bravo;

        @screen md {
          @apply block;
        }
      }
    }

    .icon-wrapper {
      @apply flex flex-col items-center justify-center;
      transition: background-color 300ms ease-out, color 300ms ease-out;
      background-image: url('~@/assets/svg/shield-with-shadow.svg?inline');
      background-repeat: no-repeat;
      width: 110px;
      height: 110px;
    }

    >>> .icon {
      @apply inline-block;

      @screen md {
        @apply block p-1;
        max-width: none;
        width: 64px;
        height: 64px;
      }
    }

    &-label {
      @apply inline-block text-black text-center;

      @screen md {
        @apply block;
      }
    }
  }

  &-top {
    @apply flex w-full flex-row justify-center;

    @screen xs {
      @apply flex w-full flex-row;
    }

    @screen lg {
      @apply justify-end;
      margin-right: 260px;
    }
  }

  &-bottom {
    @apply flex w-full mt-4;
  }

  .chat-search-container {
    @apply w-full relative;
  }

  .chat-search-input {
    @apply w-full text-xl bg-white px-11 py-4 rounded-lg focus:outline-none shadow-sm;
  }

  .chat-search-input-btn {
    @apply absolute;
    width: 48px;
    height: 48px;
    background-image: url('~@/assets/svg/chat-search-btn.svg?inline');
    top: 7px;
    right: -17px;
  }
}
</style>
